import React, { useEffect, useRef, useState } from 'react';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
};
export function Reveal({
  children,
  className = ''
}: RevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.12
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`reveal ${visible ? 'is-visible' : ''} ${className}`} data-id="element-122" data-mp="2sptjep6v9mt8">
      {children}
    </div>;
}